'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import MuiSelect, { type SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import { styled } from '@mui/material/styles';
import { InputLabel } from 'src/components/Atoms/InputLabel';
import { FormControl } from 'src/components/Molecules/FormControl';
import { Tooltip } from 'src/components/Atoms/Tooltip';
interface SelectOption {
  value: string;
  text: string;
}
const StyledFormControl = styled(FormControl)(() => ({
  '&.MuiFormControl-root': {
    alignSelf: 'unset'
  }
}));
const StyledHelpIcon = styled(HelpIcon)(({
  theme
}) => ({
  '&.MuiSvgIcon-root': {
    color: theme.colors.icon.primary,
    fontSize: theme.fonts.size.sm,
    cursor: 'pointer'
  }
}));
interface InputSelectProps {
  label?: string;
  help?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: (e: string) => void;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  options?: SelectOption[];
  showInlineLabel?: boolean;
}
const InputSelect: React.FC<InputSelectProps> = t0 => {
  const $ = _c(22);
  const {
    label,
    help,
    value: t1,
    onChange,
    name,
    disabled: t2,
    required: t3,
    options: t4,
    showInlineLabel: t5
  } = t0;
  const value = t1 === undefined ? "" : t1;
  const disabled = t2 === undefined ? false : t2;
  const required = t3 === undefined ? false : t3;
  let t6;
  if ($[0] !== t4) {
    t6 = t4 === undefined ? [] : t4;
    $[0] = t4;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const options = t6;
  const showInlineLabel = t5 === undefined ? false : t5;
  const [currentValue, setCurrentValue] = useState(value);
  let t7;
  if ($[2] !== onChange) {
    t7 = event => {
      const newValue = event.target.value as string;
      setCurrentValue(newValue);
      onChange?.(newValue);
    };
    $[2] = onChange;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const handleOnChange = t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      alignSelf: "unset"
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== help || $[6] !== label || $[7] !== showInlineLabel) {
    t9 = label && !showInlineLabel && <InputLabel>{label}{help && <Tooltip title={help} placement="top"><StyledHelpIcon /></Tooltip>}</InputLabel>;
    $[5] = help;
    $[6] = label;
    $[7] = showInlineLabel;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = label && showInlineLabel ? label : undefined;
  let t11;
  if ($[9] !== options) {
    t11 = options.map(_temp);
    $[9] = options;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== currentValue || $[12] !== disabled || $[13] !== handleOnChange || $[14] !== name || $[15] !== required || $[16] !== t10 || $[17] !== t11) {
    t12 = <MuiSelect value={currentValue} name={name} onChange={handleOnChange} disabled={disabled} required={required} label={t10}>{t11}</MuiSelect>;
    $[11] = currentValue;
    $[12] = disabled;
    $[13] = handleOnChange;
    $[14] = name;
    $[15] = required;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t9) {
    t13 = <StyledFormControl variant="standard" sx={t8}>{t9}{t12}</StyledFormControl>;
    $[19] = t12;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
export default InputSelect;
export type { InputSelectProps, SelectOption };
function _temp(option) {
  return <MenuItem key={option.value} value={option.value}>{option.text}</MenuItem>;
}